/**
 * Toast (plan 6.B) + inline confirm dialog (Q4 paid → free, leave while saving).
 */

import React, { useEffect } from "react";
import Icon from "../ui/Icon";
import { useBuilder } from "../state/builderContext";

export const BuilderToast = () => {
  const { state } = useBuilder();
  const toast = state.ui.toast;
  if (!toast) return null;
  return (
    <div className="eb-builder-toast" role="status" aria-live="polite" key={toast.id}>
      <Icon name="check" size={17} /> {toast.text}
    </div>
  );
};

export const BuilderConfirm = () => {
  const { state, closeConfirm } = useBuilder();
  const cfg = state.ui.confirm;

  useEffect(() => {
    if (!cfg) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") {
        if (cfg.onCancel) cfg.onCancel();
        else closeConfirm();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [cfg, closeConfirm]);

  if (!cfg) return null;
  const cancel = () => (cfg.onCancel ? cfg.onCancel() : closeConfirm());
  return (
    <div className="eb-confirm-backdrop" role="presentation" onMouseDown={(e) => e.target === e.currentTarget && cancel()}>
      <div className="eb-confirm" role="alertdialog" aria-modal="true" aria-labelledby="eb-confirm-title">
        <h2 id="eb-confirm-title">{cfg.title}</h2>
        {cfg.body ? <p>{cfg.body}</p> : null}
        <div>
          <button type="button" className="eb-outline-small" onClick={cancel}>
            {cfg.cancelLabel || "Cancel"}
          </button>
          <button type="button" className={`eb-top-create ${cfg.danger ? "is-danger" : ""}`.trim()} onClick={cfg.onConfirm}>
            {cfg.confirmLabel || "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BuilderToast;
